'use strict';

newsService.$inject = ["$http", "NewsItem", "api", "NewsTile", "Enums"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.newsService = newsService;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function newsService($http, NewsItem, api, NewsTile, Enums) {
    return {
        getById: getById,
        getByCriteria: getByCriteria,
        // getRecentNews: getRecentNews,
        // getPopularNews: getPopularNews,
        // getBySellerId: getBySellerId,
        getNewsForHomepage: getNewsForHomepage,
        getNewsForSellerPage: getNewsForSellerPage,
        getNewsForProduct: getNewsForProduct,
        getNewsForBrand: getNewsForBrand,
        getCategories: getCategories,
        getNewsSliderSettings: getNewsSliderSettings
    };

    function getById(id) {
        return api.news.get({ id: id }).$promise.then(function (resource) {
            return NewsItem.create(resource);
        });
    }

    function getByCriteria(searchRequest) {

        var params = {
            skip: searchRequest.skip,
            take: searchRequest.take,
            title: searchRequest.searchValue,
            productId: searchRequest.productId,
            sellerId: searchRequest.sellerId,
            brandId: searchRequest.brandId,
            categoryId: searchRequest.categoryId
        };

        return api.newsSearch.execute(params).$promise.then(function (searchResponse) {
            return searchResponse;
        });
    }

    // function getRecentNews() {
    //     return getAll().then(r => lodash.chain(r).sortBy('date').reverse().take(5).value());
    // }

    // function getPopularNews() {
    //     return getAll().then(r => lodash.chain(r).sortBy('id').take(5).value());
    // }

    // function getBySellerId(id) { 
    //     return getAll().then(r => lodash.filter(r, i => i.sellerId === id));
    // }

    function getNewsForSellerPage(id) {
        var params = {
            skip: 0,
            take: 3,
            sellerId: id
        };
        return api.newsSearch.execute(params).$promise.then(function (searchResponse) {
            return _lodash2.default.map(searchResponse.results, function (i) {
                return NewsTile.create(i);
            });
        });
    }

    function getNewsForHomepage() {
        var params = {
            skip: 0,
            take: 4
        };
        return api.newsSearch.execute(params).$promise.then(function (searchResponse) {
            return _lodash2.default.map(searchResponse.results, function (i) {
                return NewsTile.create(i);
            });
        });
    }

    function getNewsForProduct(id) {
        var params = {
            skip: 0,
            take: 3,
            productId: id
        };
        return api.newsSearch.execute(params).$promise.then(function (searchResponse) {
            return _lodash2.default.map(searchResponse.results, function (i) {
                return NewsTile.create(i);
            });
        });
    }

    function getNewsForBrand(id, skip, take) {
        var params = {
            skip: skip,
            take: take,
            brandId: id
        };
        return api.newsSearch.execute(params).$promise.then(function (searchResponse) {
            return _lodash2.default.map(searchResponse.results, function (i) {
                return NewsTile.create(i);
            });
        });
    }

    function getCategories() {
        var params = {};
        return api.newsCategories.execute(params).$promise.then(function (categories) {
            return categories;
        });
    }

    // function getTags() {
    //     return $http.get('/assets/data/tags.json')
    //         .then(function(response) { 
    //             return response.data;
    //         });
    // }

    function getNewsSliderSettings() {
        return Enums.newsSliderSettings;
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/newsService.js
// module id = 817
// module chunks = 0